module.exports = __webpack_public_path__ + "img/user-21.d83ae321.svg";